import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery, select } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { ChoosePurchaseModelDataTypes } from "../../../../Schema/choosePurchaseModel.types";
import { DiscountCodeTypes } from "../../discountCode/discountCode";
import { closeModal } from "../../modal/modal";
import { queryClient } from "../../../store";

export type BuySubServicesLoadAction = {
  type: string;
  payload: {
    sub_service_ids?: number[];
    user_service_id: number;
    use_wallet?: boolean;
    router?: any;
    serviceId?: number;
  };
};

export type BuySubServicesData = {
  data: ChoosePurchaseModelDataTypes;
};

const BuySubServices = new ReduxFetchState<
  BuySubServicesData,
  {
    sub_service_ids?: number[];
    user_service_id: number;
    use_wallet?: boolean;
    router?: any;
    serviceId?: number;
  },
  any
>("buySubServices");

export function* watchBuySubServices(action: BuySubServicesLoadAction) {
  const lang: "fa" | "en" = yield getCurrentLanguage();
  try {
    const { sub_service_ids, user_service_id, router, serviceId,use_wallet } = action.payload;

    const lang: "fa" | "en" = yield getCurrentLanguage();
    const discountCode: DiscountCodeTypes = yield select(
      (state) => state.discountCode?.discountCode,
    ) || {};

    const data: BuySubServicesData = yield axios({
      headers: {
        lang,
      },
      url: `/api/v1/ai/user-service/${user_service_id}/buy-sub-services${discountCode?.code ? "?discount_code=" + discountCode?.code : ""}`,
      method: "POST",
      data: { sub_services: sub_service_ids, user_service_id, callback_url: window.location.href, use_wallet },
    });

    yield put(closeModal());
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    queryClient.removeQueries({ queryKey: ["getSubscriptionPlans", lang] });

    if (data.data.redirect_link) {
      window.open(data.data.redirect_link, "_self");
    }

    if (!data?.data?.redirect_link && data.data.page === "chats") {
      window.location.reload();
    }

    if (data.data.page === "segment") {
      router && router(`/submit-process/service-segments/${serviceId}${sub_service_ids?.length ? `/${sub_service_ids[0]}` : ""}`);
    }

    yield put(BuySubServices.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(BuySubServices.actions.loadFailure(e.message));
  }
}

export function* buySubServicesSagas() {
  yield takeEvery(BuySubServices.actionTypes.load, watchBuySubServices);
}

export function useBuySubServices() {
  const { loading, data, ...buySubServicesState } = useAppSelector((state) => state.buySubServices);
  const dispatch = useAppDispatch();

  const dispatchBuySubServices = useCallback(
    (data: {
      sub_service_ids?: number[];
      user_service_id: number;
      use_wallet?: boolean;
      router?: any;
      serviceId?: number;
    }) => {
      dispatch(BuySubServices.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...buySubServicesState,
    dispatchBuySubServices,
    buySubServicesLoading: loading,
    buySubServicesData: data,
  };
}

export const {
  actionTypes: buySubServicesActionsTypes,
  actions: buySubServicesActions,
  reducer: buySubServicesReducer,
} = BuySubServices;
